import { render } from "./NeurologiePage.vue?vue&type=template&id=5c0f6664"
import script from "./NeurologiePage.vue?vue&type=script&lang=js"
export * from "./NeurologiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__